import PropTypes from 'prop-types';

// material-ui
import { styled } from '@mui/material/styles';
import {
  Avatar,
  Card,
  
  Divider,
  
  Grid,
  LinearProgress,
  
  Stack,
  
  Typography,
  linearProgressClasses
} from '@mui/material';

// assets

// styles
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 30,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#fff'
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main
  }
}));

// const CardStyle = styled(Card)(({ theme }) => ({
//   background: theme.palette.primary.light,
//   marginBottom: '22px',
//   overflow: 'hidden',
//   position: 'relative',
//   '&:after': {
//     content: '""',
//     position: 'absolute',
//     width: '157px',
//     height: '157px',
//     background: theme.palette.primary[200],
//     borderRadius: '50%',
//     top: '-105px',
//     right: '-96px'
//   }
// }));

// ==============================|| PROGRESS BAR WITH LABEL ||============================== //

function LinearProgressWithLabel({ value, ...others }) {
  // const theme = useTheme();

  return (
    <Grid container direction="column" spacing={1} margin={2}>
      <Grid item>
        <Grid container justifyContent="space-between">
          <Grid item>
            {/* <Typography variant="h6" sx={{ color: theme.palette.primary[800] }}>
              Progress
            </Typography> */}
          </Grid>
          <Grid item>
            <Typography variant="h6" color="inherit">{`${Math.round(value)}%`}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <BorderLinearProgress variant="determinate" value={value} {...others} />
      </Grid>
    </Grid>
  );
}

LinearProgressWithLabel.propTypes = {
  value: PropTypes.number
};

// ==============================|| SIDEBAR MENU Card ||============================== //

const MenuCard = () => {
  // const theme = useTheme();

  return (
    <Card sx={{margin:2,backgroundColor:"transparent"}}>
      <Stack direction="row" gap={2} alignItems="center" >
          <Avatar  sx={{aspectRatio:1,width:40,height:40,bgcolor:'#c8f7b7',color:"#226b07"}}>{sessionStorage.getItem("UserType").substring(0,1).toLocaleUpperCase()}</Avatar>

        <Stack gap={1} sx={{color:"#fff"}} alignItems="flex-start">
          <Typography variant="h6" color="inherit">
            {sessionStorage.getItem("UserType").toLocaleUpperCase()}
            
          </Typography>
          <Typography variant="h5" color="inherit">
            {sessionStorage.getItem('UserName')} 
          </Typography>
        </Stack>
        </Stack>
        <Divider variant="middle" flexItem sx={{marginTop:3}}/>
    </Card>
  );
};

export default MenuCard;
